import style from './block.module.scss';

const SingleArticle = ({ title, url }) => {
    return (
        <div className={style.singleArticleBlock}>
            {url && <img src={url} alt={title} className={style.singleArticleImage} />}
        </div>
    );
};

export default SingleArticle;
